module.exports = __webpack_public_path__ + "img/dhgnn.0443bc3e.png";